<template>
  <a :href="data.url" class="bg-white hover:bg-blue-50 rounded-md shadow-md p-3 flex" target="_blank">
    <div v-if="data.file !== null" class="w-full flex-shrink-0" style="width: 100px">
      <img :src="data.file.previews[Object.keys(data.file.previews)[0]]" alt="" @contextmenu.prevent.stop/>
    </div>
    <div v-else-if="data.preview !== null" class="w-full flex-shrink-0" style="width: 100px">
      <img :src="data.preview" alt="" @contextmenu.prevent.stop/>
    </div>
    <div class="text-sm pl-5 space-y-1 flex-grow">
      <div class="flex justify-between">
        <h3 class="font-bold break-words" style="word-break: break-word;" v-html="data.header"></h3>
        <span>
          <aw-icon icon="file" class="w-5 h-5 " />
        </span>
      </div>
      <div class="text-gray-400"><template v-for="(breadcrumb, index) in data.breadcrumbs" :key="index" class="text-gray-400"><template v-if="index > 0"> / </template>{{breadcrumb.name}}</template></div>
      <div>
        <table v-if="data.file !== null" class="Table table-fixed !w-auto">
          <tr>
            <td class="!border-0 py-2 px-3 pl-0 text-gray-400  whitespace-nowrap">
              <span v-if="data.file.uploaded">{{ formatDate(data.file.uploaded) }}</span>
            </td>
            <td class="!border-0 py-2 px-3 whitespace-nowrap">
              <ui-pictogram
                v-if="data.file.uploaded_by__user"
                class="ml-1"
                :user="data.file.uploaded_by__user"
              />
            </td>
            <td class="!border-0 py-2 px-3 text-gray-400 whitespace-nowrap">
              {{ data.file.ext }}
            </td>
            <td class="!border-0 py-2 px-3 text-gray-400 whitespace-nowrap">
              <document-element-file-download-link
                v-if="data.file.can_download"
                :gallery="false"
                :file="data.file"
              />
            </td>
          </tr>
        </table>

        <!-- tags -->
        <div v-if="data.tags !== null" class="flex items-center">
          <div class="space-x-2 text-gray-400">
            <aw-icon icon="tags" class="w-5 h-5 " />
            <span v-for="tag in data.tags" :key="tag" class="border border-gray-400 rounded text-xs p-y px-1 inline-block" v-html="tag"></span>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>

export default {
  mixins: [
  ],
  props: ['data', 'inicials', 'formatDate'],
}
</script>
